import { render, staticRenderFns } from "./AllowedFileTypes.vue?vue&type=template&id=3d40abc6"
import script from "./AllowedFileTypes.vue?vue&type=script&lang=js"
export * from "./AllowedFileTypes.vue?vue&type=script&lang=js"
import style0 from "./AllowedFileTypes.vue?vue&type=style&index=0&id=3d40abc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports